import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer(props) {
    const { t } = useTranslation();
    return(
        <div className="row mt-4 mb-4">
            <div className="col-lg-12">
              <a style={{color: 'initial'}} href='https://rapidaim.io/pest-forecast/'>{t('wp')}</a>
              <p>{t('copyright')}</p>
            </div>
        </div>
    );
}

export default Footer;